export enum ExperienceRoleType {
    TwentyPercentPlusOwner = 0,
    GeneralContractor = 1,
    Other = 2,
}

export const ExperienceRoleTypeOptions = [
    { id: ExperienceRoleType.TwentyPercentPlusOwner, name: '20% Plus Owner' },
    { id: ExperienceRoleType.GeneralContractor, name: 'General Contractor' },
    { id: ExperienceRoleType.Other, name: 'Other' },
];
